import AuthContext, { AuthInterface } from 'context/AuthContext'
import { useContext } from 'react'

export default () => useContext<AuthInterface | undefined>(AuthContext)
